export const SERVER_URI = process.env.VUE_APP_SERVER_URI
  ? process.env.VUE_APP_SERVER_URI
  : 'http://localhost:3000'

export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID

export const CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET
